import { FieldValues, useController, useWatch } from "react-hook-form"
import useAsyncService from "../../../hooks/useAsyncService"
import { loadExtensions } from "../../../services/APIServices"
import { useEffect, useState } from "react"
import { LoadingIndicator } from "devextreme-react/bar-gauge"
import { Button } from "devextreme-react"
import './FileExtensionList.css'
import ICSErrorCard from "../../../components/ICSErrorCard/ICSErrorCard"

export const FileExtensionPicker = ({
    name,
    control,
}) => {
    const [expandList, setExpandList] = useState(false);
    const { serviceLoading, serviceValue, serviceError, setServiceArgs } = useAsyncService<string, string[]>({
        serviceCall: loadExtensions,
        delay: 300,
        initialArgs: null
    })

    const {
        field: { value, onChange, ref },
        fieldState: { invalid, error }
    } = useController<FieldValues>({
        name,
        control
    })

    const vpick = useWatch({name: "vehiclePicker", control})

    useEffect(() => {
        const fleetParams = vpick.fleets.map(fleet => `f=${encodeURIComponent(fleet)}`).join('&')
        const vehicleParams = vpick.vehicles.map(vehicle => `v=${encodeURIComponent(vehicle)}`).join('&')
        const query = [fleetParams, vehicleParams].filter(param => param).join('&')
        
        setServiceArgs(query ? query : null) // if nothing is selected, clear
    }, [vpick])


     useEffect(() => {
        const bad:string[] = []
        value.forEach((itemer) => {
            if(serviceValue?.indexOf(itemer) === -1){
                bad.push(itemer)
            }
        })
        onChange(value.filter((i) => !bad.includes(i)))
    }, [serviceValue])

    const toggleItem = (item: string) => {
        onChange(value.indexOf(item) !== -1
            ? value.filter((i) => i !== item)
            : value.concat([item]))
    }
    
    const Output = () => {
        if(serviceLoading) {
            return <LoadingIndicator />
        } else if (serviceError) {
            return (
            <ICSErrorCard
              code={'error'}
              message={serviceError}
              fields={[]}
            />)
        } else if (serviceValue === null || serviceValue.length === 0) {
            return <div style={{fontStyle:'italic'}}>No extensions found</div>
        } else {
            return (
                <div className='dg-file-ext-container'>
                    <div className={`dg-file-ext-list search-file-ext-list ${expandList ? 'expanded-ext-list' : ''}`}>
                        <div style={{fontSize: "14px", width: "100%", height: "30px"}} className={`expand-ext-list-action chevron`} aria-label="expandlist" tabIndex={0} role="button" onClick={(e) => {e.preventDefault(); setExpandList(!expandList)}}>
                            <span style={{color: '#999'}}>Choose Extensions</span>
                            <i className={expandList ? "dx-icon dx-icon-chevronup" : "dx-icon dx-icon-chevrondown"}></i>
                        </div>
                        {serviceValue.map(i => {
                            return <Button key={`ExtPicker${name}${i}`} className={`dg-ext-btn ${(value && value.indexOf(i) === -1) ? '' : 'active'}`} onClick={() => toggleItem(i)}><div className="dg-ext-btn-text">{i}</div></Button>
                        })}
                    </div>
                </div>
            )
        }
    }

    return (
        <Output />
    )
}